import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import colors from '../../theme/foundations/colors'

export const sizeGuideStyle = {
    table: {
        width: '100%',
        margin: `${pxToRem(10)} 0`,
        thead: {
            th: {
                height: pxToRem(43),
                border: `${pxToRem(1)} solid ${colors.cav_pdp_dark_gray}`,
                backgroundColor: colors.cav_pdp_light_gray,
                color: 'black',
                textAlign: 'center',
                fontFamily: fonts.primary,
                fontSize: [`${pxToRem(12)}`, `${pxToRem(12)}`, `${pxToRem(14)}`, `${pxToRem(14)}`],
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
                letterSpacing: pxToRem(2),
                textTransform: 'uppercase'
            }
        },
        tbody: {
            'tr:nth-child(odd)': {
                td: {
                    height: pxToRem(40),
                    border: `${pxToRem(1)} solid ${colors.cav_pdp_light_gray}`,
                    backgroundColor: 'white',
                    color: 'black',
                    textAlign: 'center',
                    fontFamily: fonts.primary,
                    fontSize: [
                        `${pxToRem(14)}`,
                        `${pxToRem(14)}`,
                        `${pxToRem(16)}`,
                        `${pxToRem(16)}`
                    ],
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    letterSpacing: pxToRem(1)
                }
            },
            'tr:nth-child(even)': {
                td: {
                    height: pxToRem(40),
                    border: `${pxToRem(1)} solid ${colors.cav_pdp_light_gray}`,
                    backgroundColor: 'rgba(217, 217, 217, 0.30)',
                    color: 'black',
                    textAlign: 'center',
                    fontFamily: fonts.primary,
                    fontSize: [
                        `${pxToRem(14)}`,
                        `${pxToRem(14)}`,
                        `${pxToRem(16)}`,
                        `${pxToRem(16)}`
                    ],
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    letterSpacing: pxToRem(1)
                }
            }
        }
    }
}

export const sizeGuideModalDesc = {
    fontFamily: fonts.primary,
    fontSize: [`${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(16)}`, `${pxToRem(16)}`],
    marginTop: [`${pxToRem(0)}`],
    marginBottom: [`${pxToRem(5)}`, `${pxToRem(15)}`, `${pxToRem(30)}`, `${pxToRem(30)}`],
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textAlign: 'center',
    padding: `${pxToRem(0)} ${pxToRem(4)}`
}

export const sizeGuideModalContent = {
    paddingTop: [pxToRem(36), pxToRem(36), pxToRem(40), pxToRem(40)],
    paddingBottom: [pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)],
    paddingLeft: [pxToRem(7), pxToRem(7), pxToRem(45), pxToRem(45)],
    paddingRight: [pxToRem(7), pxToRem(7), pxToRem(45), pxToRem(45)],
    marginLeft: [pxToRem(11), pxToRem(11), 'auto', 'auto'],
    marginRight: [pxToRem(11), pxToRem(11), 'auto', 'auto'],
    borderRadius: 0,
    boxShadow: 'none'
}

export const sizeGuideModalHeader = {
    fontFamily: fonts.primary,
    marginBottom: [`${pxToRem(10)}`, `${pxToRem(10)}`, `${pxToRem(20)}`, `${pxToRem(20)}`],
    fontSize: [`${pxToRem(18)}`, `${pxToRem(18)}`, `${pxToRem(22)}`, `${pxToRem(22)}`],
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: `${pxToRem(0)} ${pxToRem(4)}`
}

export const sizeGuideModalBody = {
    padding: 0
}

export const sizeGuideModalCloseButton = {
    height: pxToRem(15),
    weight: pxToRem(15),
    position: 'absolute',
    top: [pxToRem(11), pxToRem(11), pxToRem(20), pxToRem(20)],
    right: [pxToRem(-18), pxToRem(-18), pxToRem(0), pxToRem(0)]
}

export const spinnerStyle = {
    margin: '100px auto'
}
